/**
 * Text constants for templates
 *
 * @author Mamontov Andrey, 04/2018
 */
export class TemplateMessages {

  /**
   * App
   */
  public static readonly SYSTEM_ERROR_TEXT = 'Произошла системная ошибка.';

  /**
   * Site
   */
  public static readonly NEWS_TITLE = 'Новости';
  public static readonly VETERAN_NEWS_TITLE = 'Совет ветеранов';
  public static readonly STAFF_TITLE = 'Кадровое обеспечение';
  public static readonly ABOUT_TITLE = 'О ведомстве';
  public static readonly HISTORY_NEWS_TITLE = 'История органов военной прокуратуры';
  public static readonly MANAGEMENT_TITLE = 'Руководство';
  public static readonly MANAGEMENT_HEAD_TITLE = 'Руководитель';
  public static readonly MANAGEMENT_DEPUTY_TITLE = 'Заместители';
  public static readonly RECEPTION_TITLE = 'Интернет-приемная';
  public static readonly RECEPTION_GO_TITLE = 'Обращение в органы военной прокуратуры';
  public static readonly RECEPTION_FINDER_TITLE = 'Статус обращения';
  public static readonly RECEPTION_EMAIL_CHECKER_TITLE = 'Проверка адреса электронной почты';
  public static readonly CONTACTS_TITLE = 'Контактная информация';
  public static readonly STRUCTURE_TITLE = 'Структура';
  public static readonly STRUCTURES_LIST_TITLE = 'Военные прокуратуры';
  public static readonly EVENTS_TITLE = 'Деятельность';
  public static readonly FAQ_TITLE = 'Прокурор разъясняет';
  public static readonly DOCUMENTS_TITLE = 'Документы';
  public static readonly FINANCE_INCOMES_TITLE = 'Сведения о доходах, расходах, об имуществе и обязательствах имущественного характера';
  public static readonly FINANCE_MEMBER_INCOMES_TITLE = 'Сведения о доходах, расходах, об имуществе и обязательствах имущественного характера';
  public static readonly MEMORY_BOOK_TITLE = 'Книга памяти органов военной прокуратуры';

  /**
   * Admin
   */
  /**
   * Common
   */
  public static readonly SUPERADMIN_ROLE_NAME = 'Суперадмин';

  // System
  // structure
  public static readonly STRUCTURE_A_TITLE = 'Структура сайта и панели управления';
  public static readonly STRUCTURE_A_SUB_TITLE = 'Управление структурой';
  public static readonly STRUCTURE_A_SUB2_TITLE = 'Список всех элементов структуры';
  public static readonly STRUCTURE_A_ADD_SUB2_TITLE = 'Добавление нового элемента структуры';
  public static readonly STRUCTURE_A_EDIT_SUB2_TITLE = 'Редактирование элемента структуры';
  // template
  public static readonly TEMPLATE_A_TITLE = 'Шаблоны страниц сайта';
  public static readonly TEMPLATE_A_SUB_TITLE = 'Управление шаблонами страниц сайта';
  public static readonly TEMPLATE_A_SUB2_TITLE = 'Список всех шаблонов страниц';
  public static readonly TEMPLATE_A_ADD_SUB2_TITLE = 'Добавление нового шаблона страницы';
  public static readonly TEMPLATE_A_EDIT_SUB2_TITLE = 'Редактирование шаблона страницы';
  // roles
  public static readonly ROLES_A_TITLE = 'Роли';
  public static readonly ROLES_A_SUB_TITLE = 'Управление ролями для пользователей';
  public static readonly ROLES_A_SUB2_TITLE = 'Список всех';
  public static readonly ROLES_A_ADD_SUB2_TITLE = 'Добавление новой роли';
  public static readonly ROLES_A_EDIT_SUB2_TITLE = 'Редактирование роли';
  // user
  public static readonly USER_A_TITLE = 'Пользователи';
  public static readonly USER_A_SUB_TITLE = 'Управление пользователями';
  public static readonly USER_A_SUB2_TITLE = 'Список всех';
  public static readonly USER_A_ADD_SUB2_TITLE = 'Добавление нового пользователя';
  public static readonly USER_A_EDIT_SUB2_TITLE = 'Редактирование пользователя';

  // Dictionaries
  // vp
  public static readonly VP_D_A_TITLE = 'Справочники: военные прокуратуры';
  public static readonly VP_D_A_SUB_TITLE = 'Управление данными военных прокуратур';
  public static readonly VP_D_A_SUB2_TITLE = 'Список всех военных прокуратур';
  public static readonly VP_D_A_ADD_SUB2_TITLE = 'Добавление новой военной прокуратуры';
  public static readonly VP_D_A_EDIT_SUB2_TITLE = 'Редактирование военной прокуратуры';

  // members
  public static readonly MEMBERS_D_A_TITLE = 'Справочники: работники';
  public static readonly MEMBERS_D_A_SUB_TITLE = 'Управление данными работниками';
  public static readonly MEMBERS_D_A_SUB2_TITLE = 'Список всех работников';
  public static readonly MEMBERS_D_A_ADD_SUB2_TITLE = 'Добавление нового работника';
  public static readonly MEMBERS_D_A_EDIT_SUB2_TITLE = 'Редактирование работника';

  // ranks
  public static readonly RANKS_D_A_TITLE = 'Справочники: звания';
  public static readonly RANKS_D_A_SUB_TITLE = 'Управление информацией о званиях';
  public static readonly RANKS_D_A_SUB2_TITLE = 'Список всех званий';
  public static readonly RANKS_D_A_ADD_SUB2_TITLE = 'Добавление нового звания';
  public static readonly RANKS_D_A_EDIT_SUB2_TITLE = 'Редактирование звания';

  // positions
  public static readonly POSITIONS_D_A_TITLE = 'Справочники: должности';
  public static readonly POSITIONS_D_A_SUB_TITLE = 'Управление информацией о должностях';
  public static readonly POSITIONS_D_A_SUB2_TITLE = 'Список всех должностей';
  public static readonly POSITIONS_D_A_ADD_SUB2_TITLE = 'Добавление новой должности';
  public static readonly POSITIONS_D_A_EDIT_SUB2_TITLE = 'Редактирование должности';

  // customers
  public static readonly CUSTOMERS_D_A_TITLE = 'Справочники: Заказчики';
  public static readonly CUSTOMERS_D_A_SUB_TITLE = 'Управление информацией о Заказчиках';
  public static readonly CUSTOMERS_D_A_SUB2_TITLE = 'Список всех Заказчиков';
  public static readonly CUSTOMERS_D_A_ADD_SUB2_TITLE = 'Добавление нового Заказчика';
  public static readonly CUSTOMERS_D_A_EDIT_SUB2_TITLE = 'Редактирование Заказчика';

  // customers
  public static readonly CONTRACTORS_D_A_TITLE = 'Справочники: Поставщики';
  public static readonly CONTRACTORS_D_A_SUB_TITLE = 'Управление информацией о Поставщиках';
  public static readonly CONTRACTORS_D_A_SUB2_TITLE = 'Список всех Поставщиков';
  public static readonly CONTRACTORS_D_A_ADD_SUB2_TITLE = 'Добавление нового Поставщика';
  public static readonly CONTRACTORS_D_A_EDIT_SUB2_TITLE = 'Редактирование Поставщика';

  /*  news */
  public static readonly NEWS_A_TITLE = 'Новости';
  public static readonly NEWS_A_SUB_TITLE = 'Управление новостной информацией';
  public static readonly NEWS_A_SUB2_TITLE = 'Список всех';
  public static readonly NEWS_A_ADD_SUB2_TITLE = 'Добавление новой новости';
  public static readonly NEWS_A_EDIT_SUB2_TITLE = 'Редактирование новости';

  /*  contracts */
  public static readonly CONTRACTS_A_TITLE = 'Контракты';
  public static readonly CONTRACTS_A_SUB_TITLE = 'Управление контрактами';
  public static readonly CONTRACTS_A_SUB2_TITLE = 'Список всех';
  public static readonly CONTRACTS_A_ADD_SUB2_TITLE = 'Добавление нового контракта';
  public static readonly CONTRACTS_A_EDIT_SUB2_TITLE = 'Редактирование контракта';

  /*  veteran news */
  public static readonly VETERAN_NEWS_A_TITLE = 'Новости ветеранов';
  public static readonly VETERAN_NEWS_A_SUB_TITLE = 'Управление новостной информацией';
  public static readonly VETERAN_NEWS_A_SUB2_TITLE = 'Список всех';
  public static readonly VETERAN_NEWS_A_ADD_SUB2_TITLE = 'Добавление новой новости';
  public static readonly VETERAN_NEWS_A_EDIT_SUB2_TITLE = 'Редактирование новости';

  /*  memory book */
  public static readonly MEMORY_BOOK_A_TITLE = 'Книга памяти';
  public static readonly MEMORY_BOOK_A_SUB_TITLE = 'Управление информацией';
  public static readonly MEMORY_BOOK_A_SUB2_TITLE = 'Список всех';
  public static readonly MEMORY_BOOK_A_ADD_SUB2_TITLE = 'Добавление новой информации';
  public static readonly MEMORY_BOOK_A_EDIT_SUB2_TITLE = 'Редактирование информации';

  /*  faq */
  public static readonly FAQ_A_TITLE = 'Прокурор разъясняет';
  public static readonly FAQ_A_SUB_TITLE = 'Управление информацией';
  public static readonly FAQ_A_SUB2_TITLE = 'Список всех разъяснений';
  public static readonly FAQ_A_ADD_SUB2_TITLE = 'Добавление нового разъяснения';
  public static readonly FAQ_A_EDIT_SUB2_TITLE = 'Редактирование разъяснения';

  /*  events news */
  public static readonly EVENTS_NEWS_A_TITLE = 'Мероприятия';
  public static readonly EVENTS_NEWS_A_SUB_TITLE = 'Управление информацией о мероприятиях';
  public static readonly EVENTS_NEWS_A_SUB2_TITLE = 'Список всех';
  public static readonly EVENTS_NEWS_A_ADD_SUB2_TITLE = 'Добавление нового мероприятия';
  public static readonly EVENTS_NEWS_A_EDIT_SUB2_TITLE = 'Редактирование мероприятия';

  /*  documents */
  public static readonly DOCUMENTS_A_TITLE = 'Документы';
  public static readonly DOCUMENTS_A_SUB_TITLE = 'Управление документами';
  public static readonly DOCUMENTS_A_SUB2_TITLE = 'Список всех';
  public static readonly DOCUMENTS_A_ADD_SUB2_TITLE = 'Добавление нового документа';
  public static readonly DOCUMENTS_A_EDIT_SUB2_TITLE = 'Редактирование информации о документе';

  /*  history news */
  public static readonly HISTORY_NEWS_A_TITLE = 'Статьи об истории органов военной прокуратуры';
  public static readonly HISTORY_NEWS_A_SUB_TITLE = 'Управление информацией';
  public static readonly HISTORY_NEWS_A_SUB2_TITLE = 'Список всех';
  public static readonly HISTORY_NEWS_A_ADD_SUB2_TITLE = 'Добавление новой информации';
  public static readonly HISTORY_NEWS_A_EDIT_SUB2_TITLE = 'Редактирование информации';

  /*  staff news */
  public static readonly STAFF_NEWS_A_TITLE = 'Вакансии';
  public static readonly STAFF_NEWS_A_SUB_TITLE = 'Управление информацией';
  public static readonly STAFF_NEWS_A_SUB2_TITLE = 'Список всех';
  public static readonly STAFF_NEWS_A_ADD_SUB2_TITLE = 'Добавление новой вакансии';
  public static readonly STAFF_NEWS_A_EDIT_SUB2_TITLE = 'Редактирование вакансии';

  /*  incomes */
  public static readonly INCOMES_A_TITLE = 'Сведения о доходах';
  public static readonly INCOMES_A_SUB_TITLE = 'Управление информацией';
  public static readonly INCOMES_A_SUB2_TITLE = 'Список работников';
  public static readonly INCOMES_A_ADD_SUB2_TITLE = 'Добавление новой информации';
  public static readonly INCOMES_A_EDIT_SUB2_TITLE = 'Редактирование информации';

  /* users */
  public static readonly USER_TITLE = 'Пользователи';
  public static readonly USER_SUB_TITLE = 'Управление пользователями';
  public static readonly USER_SUB2_TITLE = 'Список всех';
  public static readonly USER_ADD_SUB2_TITLE = 'Добавление нового пользователя';
  public static readonly USER_EDIT_SUB2_TITLE = 'Редактирование пользователя';

  /*  leaders */
  public static readonly LEADER_A_TITLE = 'Руководители';
  public static readonly LEADER_A_SUB_TITLE = 'Управление информацией о руководителях и их заместителях';
  public static readonly LEADER_A_SUB2_TITLE = 'Список всех';
  // public static readonly LEADER_A_ADD_SUB2_TITLE = 'Добавление нового мероприятия';
  public static readonly LEADER_A_EDIT_SUB2_TITLE = 'Редактирование информации';

  /*  complaints */
  public static readonly COMPLAINTS_A_TITLE = 'Обращения';
  public static readonly COMPLAINTS_A_SUB_TITLE = 'Просмотр информации об обращениях';
  public static readonly COMPLAINTS_A_SUB2_TITLE = 'Список всех';
  // public static readonly LEADER_A_ADD_SUB2_TITLE = 'Добавление нового мероприятия';
  public static readonly COMPLAINTS_A_VIEW_SUB2_TITLE = 'Информация об обращении';

  /* templates with filters */
  public static readonly TEMPLATE_FILTER_A_TITLE = 'Шаблоны страниц выбранного раздела';
  public static readonly TEMPLATE_FILTER_A_SUB_TITLE = 'Управление данным шаблона';
  public static readonly TEMPLATE_FILTER_A_SUB2_TITLE = 'Список всех шаблонов для выбранного раздела';
  public static readonly TEMPLATE_FILTER_A_EDIT_SUB2_TITLE = 'Редактирование информации';

  /*  home page */
  public static readonly HOME_A_TITLE = 'Домашняя страница';
  public static readonly HOME_A_SUB_TITLE = 'Общая информация о портале';
  public static readonly HOME_A_SUB2_TITLE = 'Обзор';

  /* user's profile */
  public static readonly USER_PROFILE_TITLE = 'Личный кабинет';
  public static readonly USER_PROFILE_SUB_TITLE = 'Управление персональными данными';
  public static readonly USER_PROFILE_EDIT_SUB2_TITLE = 'Просмотр данных';


}
